import React from 'react';
import { ChevronDown } from 'lucide-react';

// Toggle senza box, contenuto flush (mockup: .sc-row/.cg-head)
export interface SectionToggleProps {
  open: boolean;
  onToggle(): void;
  icon: React.ReactNode;
  title: string;                    // reso in maiuscoletto grigio 50%
  summary?: React.ReactNode;        // sunto/stato inline dopo il titolo, reso SOLO da chiuso
  trailing?: React.ReactNode;       // es. "Modifica" / "Modificato" a destra
  dataTour?: string;
  children: React.ReactNode;        // contenuto espanso, flush senza indent
}

export function SectionToggle({
  open,
  onToggle,
  icon,
  title,
  summary,
  trailing,
  dataTour,
  children,
}: SectionToggleProps): JSX.Element {
  return (
    <div data-tour={dataTour}>
      <div
        className="flex items-center gap-2 px-2 py-1.5 rounded cursor-pointer select-none hover:bg-[rgba(55,53,47,0.08)] dark:hover:bg-white/[0.06]"
        onClick={onToggle}
        role="button"
        tabIndex={0}
        aria-expanded={open}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggle(); } }}
      >
        <ChevronDown
          className={`h-3 w-3 text-[#E91E8C] transition-transform ${open ? '' : '-rotate-90'}`}
          strokeWidth={1.5}
        />
        {icon}
        <span className="text-[11px] font-medium uppercase tracking-[0.05em] text-[rgba(55,53,47,0.5)] dark:text-white/50">
          {title}
        </span>
        {/* Il sunto è il surrogato del contenuto chiuso: da aperto duplicherebbe i
            controlli che ha sotto (design M1, "chiuso → sunto"). */}
        {!open && summary}
        {trailing && <div className="ml-auto shrink-0">{trailing}</div>}
      </div>
      {open && <div className="pt-1.5 pb-1 flex flex-col gap-2">{children}</div>}
    </div>
  );
}
